import {
    downloadDocument,
    setShowSingleDocumentLoading,
} from '../../../redux/project/file/sliceProjectFileDownload';
import store from '../../../redux/store';
import {
    getProjectDocumentDetails,
    openDocumentDetailsDialog,
} from '../../../redux/project/documents/sliceProjectDocumentDetails';
import { IActionCallbackArguments } from '../../../redux/project/sliceProjectActions';
import {
    getDocNumberConvention,
    toggleDocnumberSidepanel,
} from '../../../redux/import/sliceDocnumberSidepanel';
import { checkIfPasswordIsSet } from '../../../redux/project/sliceProjectWorkflow';
import { openDeleteImportDocumentsDialog } from '../../../redux/import/sliceImportDeleteDocuments';
import { openShareEmailDialog } from '../../../redux/project/documents/sliceProjectShareEmail';
import { exportDocumentsToCSV } from '../../../redux/project/documents/sliceProjectDocumentsExportToCSV';
import { setIsOpen as showUploadDialog } from '../../../redux/import/sliceImportDialog';
import { showCategorizationDialog } from '../../../redux/general/sliceCategorization';
import { getProjectDocumentsInfo } from '../../../redux/project/documents/sliceProjectDocuments';
import {
    onAdvancedExportDocuments,
    openAdvancedExportDialog,
    setIsSingleProtocolDocumentExported,
} from '../../../redux/project/documents/sliceProjectAdvancedExportDialog';
import { openAddNoteDialog } from '../../../redux/project/documents/sliceProjectDocumentAddNote';
import { openUploadAdditionalDialog } from '../../../redux/project/documents/sliceProjectUploadAdditionalDocuments';
import {
    openRemoveAdditionalDocDialog,
    getAdditionalLinkDocument,
} from '../../../redux/project/documents/sliceProjectAdditionalDocuments';
import {
    CreateReportFromTemplateDialogEnum,
    downloadRedliningReport,
    openCreateReportFromTemplateDialog,
} from '../../../redux/project/documents/sliceProjectReportTemplate';
import { openReleaseLetterDialog } from '../../../redux/project/documents/sliceProjectDocumentAddReleaseLetter';
import { Thunk, StructureViewMode } from '../../../types';
import { openMultipleDocuments } from '../../../redux/project/documents/sliceProjectDocumentsOpenMultiple';
import { encodeBase64String } from '../../../util/StringUtils';
import {
    DocumentsStateDialogMode,
    showDocumentsStateDialog,
} from '../../../redux/project/documents/sliceProjectDocumentsActivation';
import {
    fetchExcelTemplates,
    showExcelUploadDialog,
} from '../../../redux/project/sliceProjectExcelUpload';
import {
    runDynamicAction,
    runFormdesignersDynamicAction,
} from '../../../redux/project/documents/sliceProjectDocumentsDynamicSelection';
import {
    checkDocumentFile,
    openDocumentFile,
    showFileSelectDialog,
} from '../../../redux/project/file/sliceProjectFileOpen';
import { openCreateNoticeDialog } from '../../../redux/project/documents/sliceProjectDocumentsCreateNotice';
import {
    getLinkedPartialModels,
    openSaveAssemblyDialog,
} from '../../../redux/project/documents/sliceProjectAssembly';
import {
    getProjectDocTypeIndices,
    getProjectDocTypeInfo,
} from '../../../redux/project/sliceProjectDocTypes';
import { openChangeReleaseStatusDialog } from '../../../redux/project/documents/sliceProjectAdditionalDocumentChangeReleaseStatus';
import { findProjectDocument } from '../../../util/DocUtils';
import { getProjectDocumentsFiles } from '../../../redux/project/documents/sliceProjectDocumentsFiles';
import { showAddDocumentFilesDialog } from '../../../redux/general/sliceFileUpload';
import { registerAction } from '../../../redux/general/sliceActionHandling';
import {
    getNewAssemblyIndexPartialModels,
    openNewAssemblyIndexDialog,
    setSelectedAssemblyId,
} from '../../../redux/project/documents/sliceProjectNewAssemblyIndex';
import {
    uploadVdcViewerDocument,
    removeVdcViewerDocument,
} from '../../../redux/project/documents/sliceProjectVdcCollaboration';
import { environmentVar } from '../../../Constants';

export const filingViewKeysMapperWithDefaultSubject: Record<string, string> = {
    filing_categories: '#Category#_Standard',
    filing_packages: '#Package#_Standard',
    filing_keywords: '#Keyword#_Standard',
};
/** Key mapper for filing creation action in the filing area. */
export const filingViewKeysMapper: Record<string, string> = {
    ...filingViewKeysMapperWithDefaultSubject,
    filing_addresses: '#Address#_Standard',
};

/**
 * (Development) OnClick Function.
 */
export const devOnClick = ({ replicaId, universalId, idDocIndex }: IActionCallbackArguments) => {
    console.log({ replicaId, universalId, idDocIndex });
};

const callbackDynamicAction = (params: IActionCallbackArguments) => {
    store.dispatch(runDynamicAction(params));
};

const callbackFormdesignersDynamicAction = (params: IActionCallbackArguments) => {
    store.dispatch(runFormdesignersDynamicAction(params));
};

/**
 * Prepares new Tab in order to open the document file
 */
const callbackViewMultipleFiles = async ({
    replicaId,
    areaName,
    universalId,
    fileName,
    fieldName = 'File',
    fieldIndex = '0',
    document,
}: IActionCallbackArguments) => {
    const doc = findProjectDocument(universalId, areaName) ?? document;

    if (!doc?.Files?.MultipleFiles) {
        callbackViewDocument({
            replicaId,
            areaName,
            universalId,
            fileName,
            fieldName,
            fieldIndex,
        });
        return;
    }

    store.dispatch(
        getProjectDocumentsFiles({
            replicaId,
            universalIds: [universalId],
        }),
    );
    store.dispatch(showFileSelectDialog({ universalId }));
};

/**
 * Prepares new Tab in order to open the document file
 */
const callbackViewDocument = async ({
    replicaId,
    universalId,
    documentNumber,
    fileName,
    fieldName = 'File',
    fieldIndex = '0',
}: IActionCallbackArguments) => {
    const documentFileInfo = {
        documentNumber,
        fieldName,
        fieldIndex,
    };

    /**
     * Important: IIS does not allow several special characters (like "+"), but some are allowed for standard URL.
     * Therefore needs to be encoded manually below.
     */
    const callbackURL = `/document-loader/${replicaId}/${universalId}/${encodeBase64String(
        fileName,
    )}/${encodeBase64String(JSON.stringify(documentFileInfo))}`;

    store.dispatch(
        checkDocumentFile({
            replicaId,
            universalId,
            fileName,
            fieldName,
            fieldIndex,
            callbackURL,
        }),
    );
};

/**
 * Opens multiple documents in new tabs
 */
const callbackViewMultipleDocuments = ({
    documentIds,
    replicaId,
    currentView,
}: IActionCallbackArguments) => {
    store.dispatch(openMultipleDocuments({ replicaId, documentIds, currentView }));
};

/**
 * Opens two documents in comparison mode in new tab
 */
const callbackCompareDocuments = ({ documentIds, replicaId }: IActionCallbackArguments) => {
    window.open(`/comparison-loader/${replicaId}/${documentIds.join(';')}`);
};

/**
 * Download document
 */
const callbackDownloadDocument = ({
    replicaId,
    idDocIndex,
    fileName,
    fieldName = 'File',
    fieldIndex = '0',
}: IActionCallbackArguments) => {
    store.dispatch(
        downloadDocument({
            replicaId,
            idDocIndex,
            fileName,
            fieldName,
            fieldIndex,
        }),
    );
    store.dispatch(setShowSingleDocumentLoading(true));
};

/**
 * Shows document's details.
 */
const callbackShowDocumentDetails = ({
    replicaId,
    universalId,
    idDocIndex,
}: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentDetails({
            replicaId,
            // TODO: remove TEMPORARY FIX
            universalId: universalId ?? idDocIndex,
        }),
    );
    store.dispatch(openDocumentDetailsDialog());
};

/**
 * Opens the document in a new tab
 */
const callbackOpenDocumentNewTab = ({
    replicaId,
    universalId,
    idDocIndex,
}: IActionCallbackArguments) => {
    window.open(`/document/${replicaId}/${universalId ?? idDocIndex}`, '_blank');
};

const callbackEditDocumentNumber =
    (isAdmin = false) =>
    ({ replicaId, universalId, documentIds }: IActionCallbackArguments) => {
        store.dispatch(
            getDocNumberConvention({
                replicaId,
                universalId: universalId || documentIds[0],
            }),
        );
        store.dispatch(toggleDocnumberSidepanel({ open: true, disableIndexField: isAdmin }));
    };

const callbackOpenWorkflow = ({ replicaId }: IActionCallbackArguments) =>
    store.dispatch(checkIfPasswordIsSet(replicaId));

const callbackAddNote = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(openAddNoteDialog(true));
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackAddAdditionalDocument = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(openUploadAdditionalDialog());
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackAddReleaseLetter = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(openReleaseLetterDialog());
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackShareEmail = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(openShareEmailDialog());
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackCreateReportFromTemplate = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(
        openCreateReportFromTemplateDialog(CreateReportFromTemplateDialogEnum.SelectedDocuments),
    );
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackCreateDatabaseReportFromTemplate = () => {
    store.dispatch(openCreateReportFromTemplateDialog(CreateReportFromTemplateDialogEnum.Database));
};

const callbackCreateNotice = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(openCreateNoticeDialog());
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackAdvancedExportDocuments = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(openAdvancedExportDialog());
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
};

const callbackDeleteImportDocuments = () => {
    store.dispatch(openDeleteImportDocumentsDialog());
};

const callbackCreateCategory = () => {
    console.log('createCategory');
};

const callbackCreateDocument = ({ areaName }: IActionCallbackArguments) => {
    const areaActions = {
        import: () => store.dispatch(showUploadDialog(true)),
    };

    areaActions[areaName]?.();
};

const callbackQuickReport = ({
    replicaId,
    documentIds,
    currentView,
    reportName,
}: IActionCallbackArguments) => {
    store.dispatch(exportDocumentsToCSV({ replicaId, documentIds, currentView, reportName }));
};

// TODO: Still needed?
const callbackOpenMapNewTab = () => {
    // #5791: Temporarily hardcoded URL to RAMM, for Demo purposes.
    const rammURL =
        '//de.ramm.com?database=Infrastruktur&asset=ud_bautagesbericht_bol_bu%7CBautagesbericht%20BOL-B%C3%9C%20%232%20-%2021%2f01%2f2024%7CBautagesbericht%20BOL-B%C3%9C%20%232%20-%2021%2f01%2f2024%7C10ab7776-80dd-44af-a70d-5ad5d36eebc9%7C3853aa3c-ca26-4cb7-93c0-51bf7a4b4edd';

    window.open(rammURL, '_blank');
};

const callbackCategorizeDocument =
    (type: StructureViewMode) =>
    ({ replicaId, documentIds }: IActionCallbackArguments) => {
        store.dispatch(showCategorizationDialog(type));
        store.dispatch(
            getProjectDocumentsInfo({
                replicaId,
                documentIds,
            }),
        );
    };

const callbackChangeAdditionalDocumentStatus = ({
    universalId,
    referencedMainDocId,
    replicaId,
}: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds: [referencedMainDocId],
        }),
    );
    store.dispatch(
        openChangeReleaseStatusDialog({
            universalId,
            referencedMainDocId,
        }),
    );
};

const callbackCreateTemplate = (type: string) => () => {
    store.dispatch(openDocumentDetailsDialog(type));
};

const callbackCreateFiling = ({ viewName }: IActionCallbackArguments) => {
    if (!filingViewKeysMapper[viewName]) return;
    store.dispatch(openDocumentDetailsDialog(filingViewKeysMapper[viewName]));
};

const callbackTestmodeDocuments = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
    store.dispatch(showDocumentsStateDialog(DocumentsStateDialogMode.Testmode));
};

const callbackParkDocuments = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
    store.dispatch(showDocumentsStateDialog(DocumentsStateDialogMode.Parking));
};

const callbackStopDocuments = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );
    store.dispatch(showDocumentsStateDialog(DocumentsStateDialogMode.Stopping));
};

/**
 * Opens dialog to remove additional document from the import area.
 */
const callbackRemoveAdditionalDocument = ({
    replicaId,
    universalId,
    referencedMainDocId,
    fileName,
}: IActionCallbackArguments) => {
    store.dispatch(
        openRemoveAdditionalDocDialog({
            replicaId,
            universalId,
            referencedMainDocId,
            subject: fileName,
        }),
    );
};

const callbackOpenEbaSstUrl = () => {
    window.open('https://antrag.gbbmdv.bund.de/web/eba', '_blank');
};

const callbackDocumentProtocol = ({
    replicaId,
    universalId,
    protocolName,
}: IActionCallbackArguments) => {
    store.dispatch(setIsSingleProtocolDocumentExported());
    store.dispatch(
        onAdvancedExportDocuments({
            replicaId,
            fileName: protocolName,
            universalId,
            documentTypeName: '3',
            includeInExport: ['ExportProtocol'],
            additionalFiles: [],
            protocolOnly: true,
        }),
    );
};

const callbackExcelUpload = ({ replicaId }: IActionCallbackArguments) => {
    store.dispatch(fetchExcelTemplates(replicaId));
    store.dispatch(showExcelUploadDialog());
};

const callbackCreateAssembly = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds,
        }),
    );

    const documentDocType = store
        .getState()
        .projectDocuments.data.find(doc => doc.UniversalID === documentIds[0])?.DocType;

    store.dispatch(
        getProjectDocTypeIndices({
            replicaId,
            docType: documentDocType,
        }),
    );

    store.dispatch(getLinkedPartialModels({ replicaId }));
    store.dispatch(openSaveAssemblyDialog({}));
};

const callbackEditAssembly = ({ replicaId, universalId, idDocIndex }: IActionCallbackArguments) => {
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds: [universalId],
        }),
    );

    store.dispatch(getLinkedPartialModels({ replicaId, idDocIndex }));

    const document = store
        .getState()
        .importDocuments.data.find(doc => doc.UniversalID === universalId);

    store.dispatch(
        getProjectDocTypeIndices({
            replicaId,
            docType: document?.DocType,
        }),
    );

    store.dispatch(openSaveAssemblyDialog(document));
};

const callbackDownloadRedliningReport = ({ replicaId, universalId }: IActionCallbackArguments) => {
    store.dispatch(registerAction(['redliningReport']));
    store.dispatch(downloadRedliningReport({ replicaId, universalId }));
};

const callbackShowLinkDocument = ({ replicaId, universalId }: IActionCallbackArguments) => {
    if (!store.getState().projectAdditionalDocs.linkDocumentUrlPending) {
        store.dispatch(getAdditionalLinkDocument({ replicaId, universalId }));
    }
};

const callbackAddFiles = ({
    replicaId,
    areaName,
    universalId,
    document,
}: IActionCallbackArguments) => {
    const doc = document ?? findProjectDocument(universalId, areaName);
    if (!doc) return;

    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds: [universalId],
        }),
    );
    store.dispatch(
        getProjectDocTypeInfo({
            replicaId,
            docType: doc.DocType,
        }),
    );
    store.dispatch(showAddDocumentFilesDialog({ universalId, docTypeKey: doc.DocType }));
};

const callbackCreateNewAssemblyIndex = ({ replicaId, universalId }: IActionCallbackArguments) => {
    store.dispatch(openNewAssemblyIndexDialog());
    store.dispatch(
        getProjectDocumentsInfo({
            replicaId,
            documentIds: [universalId],
        }),
    );
    store.dispatch(setSelectedAssemblyId(universalId));
};

const callbackViewVdcCollaboration = ({ replicaId, universalId }: IActionCallbackArguments) => {
    const developmentState = environmentVar ? 'qa.' : '';

    window.open(
        `https://${developmentState}cloud.thinkproject.com/vdc-reverse-proxy/viewer/${replicaId}/open?revision=${universalId}&source=eplass_cde`,
        '_blank',
    );
};

const callbackViewMultipleVdcCollaborationModels = ({
    replicaId,
    documentIds,
}: IActionCallbackArguments) => {
    const developmentState = environmentVar ? 'qa.' : '';

    const revisionIdParams = documentIds.map(documentId => `model=${documentId}`).join('&');

    window.open(
        `https://${developmentState}cloud.thinkproject.com/vdc-reverse-proxy/viewer/${replicaId}/open?${revisionIdParams}&source=eplass_cde`,
        '_blank',
    );
};

const callbackUploadVdcDocument = ({ replicaId, documentIds }: IActionCallbackArguments) => {
    store.dispatch(uploadVdcViewerDocument({ replicaId, documentIds }));
};

const callbackRemoveVdcDocument = ({
    replicaId,
    documentIds,
    universalId,
}: IActionCallbackArguments) => {
    store.dispatch(
        removeVdcViewerDocument({ replicaId, documentIds: documentIds || [universalId] }),
    );
};

// ToDo: Remove after Demo.
const callbackVdcViewerLink = () => {
    window.open(
        `https://qa.cloud.thinkproject.com/vdc-collaboration/viewer/?project=f2708270-8f07-4117-9e7c-a64a933c0ab1&model=01979b90-54fa-7356-9477-9de636fda72f&lang=de`,
        '_blank',
    );
};

export const docTableActionsCallbacks = {
    addAdditionalDocument: callbackAddAdditionalDocument,
    addFiles: callbackAddFiles,
    addNote: callbackAddNote,
    addNoteAdmin: callbackAddNote,
    assignKeyword: callbackCategorizeDocument('Keyword'),
    assignKeywordAdmin: callbackCategorizeDocument('Keyword'),
    assignAddress: callbackCategorizeDocument('Address'),
    assignAddressAdmin: callbackCategorizeDocument('Address'),
    addReleaseLetter: callbackAddReleaseLetter,
    advancedExport: callbackAdvancedExportDocuments,
    advancedReport: callbackCreateReportFromTemplate,
    bulkUploadPackages: callbackExcelUpload,
    categorizeDocument: callbackCategorizeDocument('Category'),
    categorizeDocumentAdmin: callbackCategorizeDocument('Category'),
    createAssembly: callbackCreateAssembly,
    createCategory: callbackCreateCategory,
    createDocument: callbackCreateDocument,
    createEmailTemplate: callbackCreateTemplate('#Template#_Mail'),
    createExcelReportTemplate: callbackCreateTemplate('#Template#_ExcelReport'),
    createDistributionGroup: callbackCreateTemplate('#Template#_DistributionGroup'),
    createNotice: callbackCreateNotice,
    createNoticeTemplate: callbackCreateTemplate('#Template#_Notice'),
    createFilingCategory: callbackCreateFiling,
    createNewAssemblyIndex: callbackCreateNewAssemblyIndex,
    compareDrawings: callbackCompareDocuments,
    databaseReport: callbackCreateDatabaseReportFromTemplate,
    deleteImport: callbackDeleteImportDocuments,
    documentProtocol: callbackDocumentProtocol,
    download: callbackDownloadDocument,
    dynamicAction: callbackDynamicAction,
    formdesignersDynamicAction: callbackFormdesignersDynamicAction,
    ebaSstLink: callbackOpenEbaSstUrl,
    editAssembly: callbackEditAssembly,
    editDocumentNumber: callbackEditDocumentNumber(false),
    editDocumentNumberAdmin: callbackEditDocumentNumber(true),
    map: callbackOpenMapNewTab,
    open: devOnClick,
    openNewTab: callbackOpenDocumentNewTab,
    packageDocument: callbackCategorizeDocument('Package'),
    packageDocumentAdmin: callbackCategorizeDocument('Package'),
    parking: callbackParkDocuments,
    print: devOnClick,
    redliningReport: callbackDownloadRedliningReport,
    registerUser: callbackCreateTemplate('#Document#_ProjectControl_Job_UserRegister'),
    changeStatus: callbackChangeAdditionalDocumentStatus,
    changeStatusAdmin: callbackChangeAdditionalDocumentStatus,
    removeAdditionalDocument: callbackRemoveAdditionalDocument,
    removeVdcDocument: callbackRemoveVdcDocument,
    report: callbackQuickReport,
    shareEmail: callbackShareEmail,
    showDetails: callbackShowDocumentDetails,
    showLinkDocument: callbackShowLinkDocument,
    stopping: callbackStopDocuments,
    testMode: callbackTestmodeDocuments,
    uploadVdcDocument: callbackUploadVdcDocument,
    vdcViewerLink: callbackVdcViewerLink,
    view: callbackViewDocument,
    viewAttachments: devOnClick,
    viewEmail: callbackViewDocument,
    viewMultiple: callbackViewMultipleDocuments,
    viewMultipleFiles: callbackViewMultipleFiles,
    viewNotice: callbackViewDocument,
    viewMultipleVdcCollaborationModels: callbackViewMultipleVdcCollaborationModels,
    viewVdcCollaboration: callbackViewVdcCollaboration,
    viewWithOptions: callbackViewDocument,
    workflow: callbackOpenWorkflow,
};

export const docTableActionsThunksMap: Record<ActionName, Thunk[]> = {
    addAdditionalDocument: [getProjectDocumentsInfo],
    addFiles: [getProjectDocumentsInfo, getProjectDocTypeInfo],
    addNote: [getProjectDocumentsInfo],
    addNoteAdmin: [getProjectDocumentsInfo],
    assignKeyword: [getProjectDocumentsInfo],
    assignKeywordAdmin: [getProjectDocumentsInfo],
    assignAddress: [getProjectDocumentsInfo],
    assignAddressAdmin: [getProjectDocumentsInfo],
    addReleaseLetter: [getProjectDocumentsInfo],
    advancedExport: [getProjectDocumentsInfo],
    advancedReport: [getProjectDocumentsInfo],
    bulkUploadPackages: [fetchExcelTemplates],
    categorizeDocument: [getProjectDocumentsInfo],
    categorizeDocumentAdmin: [getProjectDocumentsInfo],
    changeStatus: [getProjectDocumentsInfo],
    changeStatusAdmin: [getProjectDocumentsInfo],
    createAssembly: [getProjectDocumentsInfo, getProjectDocTypeIndices, getLinkedPartialModels],
    createCategory: [],
    createDocument: [],
    createEmailTemplate: [],
    createExcelReportTemplate: [],
    createDistributionGroup: [],
    createNotice: [getProjectDocumentsInfo],
    createNoticeTemplate: [],
    createFilingCategory: [],
    createNewAssemblyIndex: [getNewAssemblyIndexPartialModels],
    compareDrawings: [],
    databaseReport: [],
    deleteImport: [],
    documentProtocol: [onAdvancedExportDocuments],
    download: [downloadDocument],
    dynamicAction: [runDynamicAction],
    formdesignersDynamicAction: [runFormdesignersDynamicAction],
    ebaSstLink: [],
    editAssembly: [getProjectDocumentsInfo, getLinkedPartialModels, getProjectDocTypeIndices],
    editDocumentNumber: [getDocNumberConvention],
    editDocumentNumberAdmin: [getDocNumberConvention],
    map: [],
    open: [],
    openNewTab: [],
    packageDocument: [getProjectDocumentsInfo],
    packageDocumentAdmin: [getProjectDocumentsInfo],
    parking: [getProjectDocumentsInfo],
    print: [],
    redliningReport: [downloadRedliningReport],
    registerUser: [],
    removeAdditionalDocument: [],
    removeVdcDocument: [removeVdcViewerDocument],
    report: [exportDocumentsToCSV],
    shareEmail: [getProjectDocumentsInfo],
    showDetails: [getProjectDocumentDetails],
    showLinkDocument: [getAdditionalLinkDocument],
    stopping: [getProjectDocumentsInfo],
    testMode: [getProjectDocumentsInfo],
    uploadVdcDocument: [uploadVdcViewerDocument],
    vdcViewerLink: [],
    view: [checkDocumentFile, openDocumentFile],
    viewAttachments: [],
    viewEmail: [checkDocumentFile, openDocumentFile],
    viewMultiple: [openMultipleDocuments],
    viewMultipleFiles: [checkDocumentFile, openDocumentFile, getProjectDocumentsFiles],
    viewNotice: [checkDocumentFile, openDocumentFile],
    viewMultipleVdcCollaborationModels: [],
    viewVdcCollaboration: [],
    viewWithOptions: [checkDocumentFile, openDocumentFile],
    workflow: [checkIfPasswordIsSet],
};

export type ActionName = keyof typeof docTableActionsCallbacks;
